
namespace Matrix.Dashboards {

    @Serenity.Decorators.registerClass()
    export class WidgetCatalogGrid extends SiteEntityGrid<WidgetCatalogRow, any> {
        protected getColumnsKey() { return 'Dashboards.WidgetCatalog'; }
        protected getDialogType() { return WidgetCatalogDialog; }
        protected getIdProperty() { return WidgetCatalogRow.idProperty; }
        protected getInsertPermission() { return WidgetCatalogRow.insertPermission; }
        protected getLocalTextPrefix() { return WidgetCatalogRow.localTextPrefix; }
        protected getService() { return WidgetCatalogService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}